import React, { Component } from 'react';
import ProjectHeader from '../ProjectHeader';
import Header from '../../assets/images/dropracing/__header.png';
import IllustrationDropRacing from '../../assets/images/dropracing/__screens.gif';

class ProjectDropRacing extends Component {
	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Drop Racing</h1>
				<span className="title-caption step-4">A Tetris adaptation fused with motorsport racing</span>
				<div className="publish-container">
					<img src={Header} alt="Caption for single image" />
					<p>
						In this game, the first player to drop all the pieces in the track wins.<br></br>
						The goal is to play as fast as he can to win races and set fastest times.
					</p>
					<p>
						You can check the game{' '}
						<a href="https://store.steampowered.com/app/2741400/Drop_Racing/" aria-label="Link to game" target="_blank" className="link">
							here
						</a>{' '} or get more info{' '}
						<a href="https://freakiestshow.pt/dropracing/" aria-label="Link to game" target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" href="https://store.steampowered.com/app/2741400/Drop_Racing/">
						<img to="/" src={IllustrationDropRacing} alt="Drop Racing game screenshots" />
					</a>
					<p>
						This project was made using Unity (in C#), VS Code, Figma, Affinity Photo and Audacity.<br></br>
						I worked on this as a solo developer, and made all the code, sound effects, design assets and textures.
					</p>
					<p>Thank you.</p>
				</div>
			</div>
		);
	}
}

export default ProjectDropRacing;
